import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=093f45d4&scoped=true"
import script from "./RoleSetting.vue?vue&type=script&lang=js"
export * from "./RoleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093f45d4",
  null
  
)

export default component.exports